import { DialogContent } from '@/components/ui/dialog';

export function MobileSheetContent({ className = '', children, ...props }) {
  return (
    <DialogContent
      className={`!fixed !bottom-0 !left-[1px] !top-auto !max-h-[88vh] !w-[calc(100vw-2px)] !max-w-[calc(100vw-2px)] !translate-x-0 !translate-y-0 overflow-x-hidden overflow-y-auto rounded-t-2xl border-x-0 border-b-0 p-4 shadow-2xl data-[state=open]:slide-in-from-bottom-full sm:!bottom-auto sm:!left-[50%] sm:!top-[50%] sm:!max-h-[92vh] sm:!w-full sm:!max-w-lg sm:!translate-x-[-50%] sm:!translate-y-[-50%] sm:rounded-lg sm:border sm:p-6 ${className}`}
      {...props}
    >
      <div className="mx-auto mb-2 h-1 w-12 rounded-full bg-zinc-300 sm:hidden" data-testid="mobile-sheet-grabber" />
      {children}
    </DialogContent>
  );
}

export function MobileSheetActions({ children, className = '', testId = 'mobile-sheet-actions' }) {
  return (
    <div className={`sticky bottom-0 z-10 mx-0 mt-4 border-t border-zinc-200 bg-white/95 p-3 pb-[max(env(safe-area-inset-bottom),0.75rem)] backdrop-blur sm:static sm:border-t-0 sm:bg-transparent sm:p-0 ${className}`} data-testid={testId}>
      <div className="grid grid-cols-1 gap-2 sm:flex sm:flex-wrap">{children}</div>
    </div>
  );
}

export function DesktopQuickActionsRail({ children, className = '', testId = 'desktop-quick-actions-rail' }) {
  return (
    <div className={`hidden sm:fixed sm:right-5 sm:top-1/2 sm:z-[70] sm:flex sm:-translate-y-1/2 sm:flex-col sm:gap-2 sm:rounded-full sm:border sm:border-zinc-200 sm:bg-white/95 sm:p-2 sm:shadow-xl sm:backdrop-blur ${className}`} data-testid={testId}>
      {children}
    </div>
  );
}

export function DesktopRailButton({ children, href, onClick, testId, title }) {
  const className = "inline-flex h-10 w-10 items-center justify-center rounded-full bg-zinc-950 text-white transition-colors hover:bg-orange-600";
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" className={className} title={title} data-testid={testId}>{children}</a>;
  return <button type="button" onClick={onClick} className={className} title={title} data-testid={testId}>{children}</button>;
}